import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './QueryClient';

/**
 * Provider component that wraps the application with React Query context.
 * Use this at the root of your app to enable React Query hooks.
 */
export const AppQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default AppQueryProvider;
